/******/ (() => { // webpackBootstrap
/*!****************************************************!*\
  !*** ./_build/scripts/snippets/personalisation.js ***!
  \****************************************************/
const PROFANITIES = [
  "shit", "fuck", "4r5e", "5h1t", "5hit", "a_s_s", "a$$", "a$$hole", "aeolus", "ahole",
  "anal", "anus", "arsehole", "ass", "assfuck", "asshole", "assbang", "assbangs", "asses",
  "assfukka", "assh0le", "asshat", "assho1e", "assholes", "assmucus", "assmunch", "asswhole",
  "asswipe", "asswipes", "azz", "b!tch", "b00bs", "b17ch", "b1tch", "ballbag", "ballsack",
  "bangbros", "bastard", "bastards", "beaner", "beatch", "beeyotch", "bellend", "beotch",
  "bi+ch", "biatch", "bigtits", "birdlock", "bitch", "bitchtit", "bitched", "bitcher",
  "bitchers", "bitches", "bitchin", "bitching", "bitchy", "blowjob", "blowme", "blowmud",
  "blowjobs", "blumpkin", "boiolas", "bollock", "bollocks", "bollok", "boner", "boners",
  "boob", "boobies", "boobs", "booby", "booobs", "boooobs", "booooobs", "buceta", "bukkake",
  "bullshit", "buttfuck", "butthole", "buttplug", "c-0-c-k", "c-o-c-k", "c-u-n-t", "c.0.c.k",
  "c.o.c.k.", "c.u.n.t", "c0ck", "cameltoe", "cawk", "chinc", "chincs", "chink", "choade",
  "chode", "chodes", "cipa", "cl1t", "clit", "clitoris", "clitorus", "clits", "clitty",
  "cocain", "cocaine", "cock", "cocksnot", "cockface", "cockhead", "cocks", "cocksuck",
  "cocksuka", "coital", "coksucka", "commie", "coon", "coons", "cornhole", "cum", "cumfreak",
  "cumdump", "cummer", "cummin", "cums", "cumshot", "cumshots", "cumslut", "cumstain",
  "cunny", "cunt", "cunthair", "cuntbag", "cuntface", "cuntlick", "cunts", "cutrope",
  "cyberfuc", "d0ng", "d0uch3", "d0uche", "d1ck", "d1ld0", "d1ldo", "dago", "dagos",
  "dick", "dickhole", "dickshy", "dick-ish", "dickbag", "dickface", "dickhead", "dickish",
  "dickweed", "diddle", "dike", "dildo", "dildos", "diliga", "dirsa", "dlck", "douch3",
  "douche", "douchey", "dumass", "dumbass", "eatadick", "essohbee", "Fatcunt", "fucker",
  "f_u_c_k", "f-u-c-k", "f.u.c.k", "f4nny", "fack", "fag", "fagg", "fagged", "fagging",
  "faggit", "faggitt", "faggot", "faggs", "fagot", "fagots", "fags", "fatass", "fcuker",
  "fcuking", "feck", "fecker", "felch", "felcher", "felching", "fellate", "fellatio",
  "feltch", "feltcher", "fistfuck", "flange", "fook", "fooker", "foreskin", "frigg",
  "frigga", "fuckhole", "fuck-ass", "fucka", "fuckass", "fucked", "fuckers", "fuckface",
  "fuckhead", "fuckin", "fucking", "fuckings", "fuckme", "fuckmeat", "fucknut", "fuckoff",
  "fucks", "fucktard", "fucktoy", "fuckup", "fuckwad", "fuckwhit", "fuckwit", "fuk",
  "fuker", "fukker", "fukkin", "fuks", "fukwhit", "fukwit", "fux", "fux0r", "g-spot",
  "gangbang", "gassyass", "gaylord", "gaysex", "gook", "gooks", "guido", "h0m0", "h0mo",
  "hamflap", "handjob", "hebe", "heeb", "herpes", "hitler", "hoar", "hoare", "hobag",
  "hoer", "hom0", "homo", "homoey", "honky", "hooker", "hotsex", "hussy", "inbred",
  "incest", "injun", "j3rk0ff", "jack-off", "jackhole", "jackoff", "jap", "japs", "jerk",
  "jerk-off", "jerk0ff", "jerked", "jerkoff", "jism", "jiz", "jizm", "jizz", "jizzed",
  "kawk", "kike", "kikes", "kkk", "klan", "knob", "knobend", "knobead", "knobed",
  "knobhead", "kock", "kooch", "kooches", "kootch", "kraut", "kyke", "l3i+ch", "l3itch",
  "lech", "leper", "lesbo", "lesbos", "lezbo", "lezbos", "m0f0", "m0fo", "ma5terb8",
  "mafugly", "masterb8", "mo-fo", "mof0", "mofo", "molest", "moolie", "muff", "muffpuff",
  "n1gga", "n1gger", "nazi", "nazism", "negro", "nigg3r", "nigg4h", "nigga", "niggah",
  "niggas", "niggaz", "nigger", "niggers", "niggle", "niglet", "ninny", "nobjokey",
  "nobhead", "nobjocky", "numbnuts", "nutsack", "opiate", "orgasim", "orgasims", "orgasm",
  "orgasmic", "orgasms", "orgies", "orgy", "p0rn", "paki", "pecker", "pedo", "penial",
  "penile", "penis", "phallic", "phonesex", "phuked", "phuking", "phukked", "phukking",
  "piss", "piss-off", "pisser", "pissers", "pisses", "pissin", "pissing", "pissoff",
  "poontang", "porn", "porno", "pornos", "prick", "pricks", "prig", "prude", "pube",
  "pubic", "pubis", "punkass", "puss", "pusse", "pussi", "pussies", "pussy", "pussys",
  "puto", "queaf", "queef", "quim", "r-tard", "rape", "raped", "raper", "rapist", "rectal",
  "rectum", "rectus", "reetard", "retard", "retarded", "rimjaw", "rimjob", "rimming",
  "ritard", "rtard", "s_h_i_t", "s-h-1-t", "s-h-i-t", "s-o-b", "s.h.i.t.", "schizo",
  "schlong", "scroat", "scrot", "scrote", "scrotum", "scrud", "scum", "semen", "sh!+",
  "sh!t", "sh1t", "shag", "shagger", "shaggin", "shagging", "shemale", "shi+", "shitdick",
  "shite", "shited", "shitey", "shitface", "shitfuck", "shitfull", "shithead", "shithole",
  "shiting", "shitings", "shits", "shitt", "shitted", "shitter", "shitters", "shitting",
  "shitty", "sissy", "skag", "skank", "slave", "sleaze", "sleazy", "slut", "slutkiss",
  "sluts", "smegma", "smut", "smutty", "snatch", "spac", "spic", "spick", "spik", "spiks",
  "spooge", "spunk", "stfu", "t1t", "t1tt1e5", "t1tties", "tard", "teets", "teez", "terd",
  "tit", "titwank", "titfuck", "titi", "tits", "titt", "tittie5", "titties", "titty",
  "tosser", "tramp", "turd", "tw4t", "twat", "twathead", "twats", "twatty", "twunt",
  "twunter", "vag", "wank", "wanker", "wanky", "wench", "wh0re", "whoar", "whore",
  "whored", "whores", "whoring", "wigger", "wop", "zoophile"
];

function containsProfanity(text) {
  if (!text) return false;
  return PROFANITIES.some((word) => new RegExp(`\\b${word}\\b`, 'i').test(text));
}

document.querySelectorAll('[data-personalisation]').forEach((el) => {
  const form = el.closest('form');
  if (!form) return;

  const tabs = Array.from(el.querySelectorAll('[data-personalisation-tab]'));
  const playerPanel = el.querySelector('[data-personalisation-panel="player"]');
  const customPanel = el.querySelector('[data-personalisation-panel="custom"]');
  const playerSelect = el.querySelector('[data-personalisation-player-select]');
  const numberInput = el.querySelector('[data-personalisation-number]');
  const nameInput = el.querySelector('[data-personalisation-name]');
  const propPlayer = el.querySelector('[data-personalisation-prop-player]');
  const propNumber = el.querySelector('[data-personalisation-prop-number]');
  const propName = el.querySelector('[data-personalisation-prop-name]');
  const errorEl = el.querySelector('[data-personalisation-error]');

  let activeTab = 'player';

  function getVariantId() {
    const id20 = Number(el.dataset.personalisationVariantId);
    const id10 = Number(el.dataset.personalisationVariantIdNameOnly);
    if (activeTab === 'player') return id20;
    // Custom tab: name + number → £20, name only → £10
    const num = numberInput ? numberInput.value.trim() : '';
    const name = nameInput ? nameInput.value.trim() : '';
    return (num && name) ? id20 : id10;
  }

  function setTab(tab) {
    activeTab = tab;
    tabs.forEach((btn) => {
      btn.setAttribute('aria-selected', String(btn.dataset.personalisationTab === tab));
    });
    if (playerPanel) playerPanel.hidden = tab !== 'player';
    if (customPanel) customPanel.hidden = tab !== 'custom';
    clearError();
    clearProps();
  }

  function clearProps() {
    if (propPlayer) propPlayer.value = '';
    if (propNumber) propNumber.value = '';
    if (propName) propName.value = '';
  }

  function clearError() {
    if (errorEl) errorEl.textContent = '';
  }

  function showError(msg) {
    if (errorEl) errorEl.textContent = msg;
  }

  function isPersonalisationActive() {
    if (activeTab === 'player') {
      return playerSelect ? playerSelect.value !== '' : false;
    }
    const name = nameInput ? nameInput.value.trim() : '';
    return name !== '';
  }

  function syncProps() {
    clearProps();
    if (activeTab === 'player') {
      if (propPlayer) propPlayer.value = playerSelect ? playerSelect.value : '';
    } else {
      if (propNumber) propNumber.value = numberInput ? numberInput.value.trim() : '';
      if (propName) propName.value = nameInput ? nameInput.value.trim() : '';
    }
  }

  function validate() {
    clearError();
    if (activeTab === 'custom') {
      const num = numberInput ? numberInput.value.trim() : '';
      const name = nameInput ? nameInput.value.trim() : '';
      if (num && !name) {
        showError('Please also enter a name.');
        return false;
      }
      if (containsProfanity(name)) {
        showError('The name entered is not permitted.');
        return false;
      }
    }
    if (activeTab === 'player') {
      const player = playerSelect ? playerSelect.value : '';
      if (containsProfanity(player)) {
        showError('The name entered is not permitted.');
        return false;
      }
    }
    return true;
  }

  // Tab switching
  tabs.forEach((btn) => {
    btn.addEventListener('click', () => setTab(btn.dataset.personalisationTab));
  });

  // Sort player dropdown numerically (Liquid sort doesn't work on metaobject fields)
  if (playerSelect) {
    const placeholder = playerSelect.options[0];
    const opts = Array.from(playerSelect.options).slice(1);
    opts.sort((a, b) => parseInt(a.text, 10) - parseInt(b.text, 10));
    playerSelect.innerHTML = '';
    playerSelect.appendChild(placeholder);
    opts.forEach((opt) => playerSelect.appendChild(opt));

    playerSelect.addEventListener('change', syncProps);
  }

  // Input filtering
  if (numberInput) {
    numberInput.addEventListener('input', () => {
      numberInput.value = numberInput.value.replace(/\D/g, '');
      syncProps();
    });
  }
  if (nameInput) {
    nameInput.addEventListener('input', () => {
      nameInput.value = nameInput.value.replace(/\d/g, '');
      syncProps();
    });
  }

  // Capture-phase submit: when personalisation is active, take over the entire
  // add-to-cart flow so both the main product and personalisation item are added
  // atomically in one request before redirecting to /cart.
  form.addEventListener('submit', async (e) => {
    syncProps();

    if (!validate()) {
      e.preventDefault();
      e.stopImmediatePropagation();
      return;
    }

    if (!isPersonalisationActive()) return;

    const variantId = getVariantId();
    if (!variantId) {
      console.warn('[Personalisation] No variant ID configured — skipping personalisation.');
      return;
    }

    // Take over the submit entirely.
    e.preventDefault();
    e.stopImmediatePropagation();

    const formData = new FormData(form);
    const mainId = Number(formData.get('id'));
    const quantity = Number(formData.get('quantity')) || 1;

    // Build main product properties from form data (excludes empty values).
    const properties = {};
    for (const [key, value] of formData.entries()) {
      if (key.startsWith('properties[') && value !== '') {
        properties[key.slice(11, -1)] = value;
      }
    }

    const submitBtn = form.querySelector('[data-product-submit-button]');
    if (submitBtn) submitBtn.disabled = true;

    try {
      const res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          items: [
            { id: mainId, quantity, properties },
            { id: variantId, quantity, properties: { '_parent_variant': String(mainId) } },
          ],
        }),
      });

      if (!res.ok) {
        const data = await res.json().catch(() => ({}));
        showError(data.description || 'Could not add to cart. Please try again.');
        if (submitBtn) submitBtn.disabled = false;
        return;
      }

      window.location.href = '/cart';
    } catch (err) {
      console.error('[Personalisation] Add to cart failed:', err);
      showError('Could not add to cart. Please try again.');
      if (submitBtn) submitBtn.disabled = false;
    }
  }, { capture: true });
});

/******/ })()
;